window.VH = window.VH === undefined ? {} : window.VH;

VH.UserForm = {
    roleSelect : null,
    personContainer : null,
    regionContainer : null,

    checkPersonContainer : function checkPersonContainer()
    {
        let _t = VH.UserForm,
            role = _t.roleSelect.val()
        ;
        if (role === 'client') {
            _t.personContainer.hide();
        } else {
            _t.personContainer.show();
        }
        if (role === 'regional_se') {
            _t.regionContainer.show();
        } else {
            _t.regionContainer.hide();
        }
    },

    init : function init()
    {
        let _t = VH.UserForm;
        _t.roleSelect = $('#user-role');
        _t.personContainer = $('#person_code_container');
        _t.regionContainer = $('#region_store_container');

        _t.roleSelect.on('change', _t.checkPersonContainer);

        _t.checkPersonContainer();
    }

};
